import { adminPermissions } from "../organization/members/permissions/permissionSamples.js";

const ROLES_ALIAS = {
  ORGANIZATION_USER: "ORGANIZATION_USER",
  ADMINISTRATOR: "ADMINISTRATOR",
  GUEST_SPEAKER: "GUEST_SPEAKER",
  PARTICIPANT: "PARTICIPANT",
};
const ACTIONS = {
  read: "read",
  create: "read",
  edit: "edit",
  remove: "remove",
};
const ROOM_PERMISSIONS = {
  GO_LIVE: "ROOM_GO_LIVE",
  JOIN_STUDIO: "ROOM_JOIN_STUDIO",
  MODERATE: "ROOM_MODERATE",
  ADMINISTRATE: "ROOM_ADMINISTRATE",
  BASE: "ROOM_BASE",
};

const canUser = (roomId, currentUser, resource, action) => {
  if (currentUser?.roomInfo?.permission) {
    const roomInfo = currentUser.roomInfo.permission.find(
      (r) => r?._id?.toString() === roomId?.toString(),
    );
    return roomInfo?.permission[resource]?.[action] || false;
  }
  return false;
};

/**
 * Orchestration function to obtain a currentUser objects permissions for an organization.
 * Preferably, this should be refactored into organization or moved to redux
 */
const getUserOrganizationPermissions = (currentUser, organizationId) => {
  const memberPermissions =
    (currentUser?.organizationInfo?.organizations ?? []).find(
      (organization) => organization._id === organizationId,
    )?.memberPermissions ?? null;

  return memberPermissions?.admin ? adminPermissions : memberPermissions;
};

export {
  ROLES_ALIAS,
  ACTIONS,
  ROOM_PERMISSIONS,
  canUser,
  getUserOrganizationPermissions,
};
